import type { HeaderMenuItemGroup } from '@snapchat/mw-contentful-schema';
import { NavigatorItemDesktop as NavigatorItemDesktopSDS } from '@snapchat/snap-design-system-marketing';
import { type FC, useContext } from 'react';

import { ElementLocation } from '../../context/ElementLocationContext/ElementLocationContext';
import { shouldFlushLogs } from '../../helpers/getLocalPath';
import { logger, logUserEvent } from '../../helpers/logging';
import { UserAction } from '../../types/events';
import { getContentfulInspectorProps } from '../../utils/contentful/getContentfulInspectorProps';
import type { NavigatorGroupProps } from '../Header/headerNavGroupUtils';

interface LocalNavDesktopProps {
  items?: NavigatorGroupProps[];
}

export const LocalNavDesktop: FC<LocalNavDesktopProps> = ({ items }) => {
  const elementLocation = useContext(ElementLocation).elementLocation;

  if (!items || !items.length) {
    return null;
  }

  const getItemDataset = (id: string) => {
    const { contentfulDescriptionDataset } = getContentfulInspectorProps<HeaderMenuItemGroup>({
      entryId: id,
      fieldIds: ['contentfulDescription'],
    });

    return contentfulDescriptionDataset;
  };

  return (
    <>
      {items.map(item => {
        const {
          sys,
          url,
          title,
          isSelected,
          analytics,
          column1Label,
          column1Items,
          column2Label,
          column2Items,
          column3Label,
          column3Items,
          featuredMenuItem,
        } = item;
        const id = sys.id;

        const handleClick = (clickUrl: string, analyticsId?: string): void => {
          logUserEvent({
            eventCategory: 'NavigatorItem',
            eventAction: UserAction.Click,
            eventLabel: analyticsId ?? clickUrl,
            context: { targetUrl: clickUrl, elementText: title, elementLocation },
          });

          if (shouldFlushLogs(clickUrl)) {
            void logger.flush();
          }
        };

        return (
          <NavigatorItemDesktopSDS
            key={id}
            dataset={getItemDataset(id)}
            id={id}
            url={url ?? ''}
            isSelected={isSelected}
            title={title ?? ''}
            analytics={analytics?.label ? { label: analytics.label } : undefined}
            col1Label={column1Label}
            col1Items={column1Items}
            col2Label={column2Label}
            col2Items={column2Items}
            col3Label={column3Label}
            col3Items={column3Items}
            featuredItem={featuredMenuItem}
            onClick={handleClick}
          />
        );
      })}
    </>
  );
};
